var map = {
	"./barre-1.png": "dba5",
	"./barre-10.png": "314c",
	"./barre-2.png": "5eee",
	"./barre-3.png": "cdb1",
	"./barre-4.png": "2cfa",
	"./barre-5.png": "e7f8",
	"./barre-6.png": "35b6",
	"./barre-7.png": "71e5",
	"./barre-8.png": "2ee9",
	"./barre-9.png": "62eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4cbd";